/**
 * "Sí" / "No" para las banderas "Y"/"N" del back, en una celda de grilla.
 *
 * UN VALOR AUSENTE DA VACÍO, NO "No". Mientras el back no mande el campo, pintar "No" en
 * todas las filas sería afirmar algo que no sabemos —y encima afirmarlo con la misma cara
 * que va a tener el dato real—. La celda vacía se lee como "todavía no hay dato", que es
 * lo que pasa, y el día que el back empiece a mandarlo la columna se llena sola.
 *
 * Vive acá y no en la carpeta de una vista porque la comparten los permisos de repartición
 * (estructuras) y el "Puede editar" de cargos (personal). Mismo criterio que
 * `etiquetaUnico` en consts/asignaciones.
 *
 * No devuelve el crudo cuando el código es inesperado, a diferencia de `etiquetaUnico`:
 * estas banderas las escribimos nosotros desde un checkbox, así que "Y" y "N" son los dos
 * únicos valores que pueden llegar.
 */
const SI_NO = { Y: "Sí", N: "No" };

export const etiquetaSiNo = (cod) => SI_NO[cod] ?? "";
